import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//primereact
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Timeline } from "primereact/timeline";
import { Skeleton } from "primereact/skeleton";
//components
import Modal from "../../../../components/modal/Modal";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import MaskInput from "../../../../components/input/MaskInput";
import TextareaInput from "../../../../components/input/TextareaInput";
//utils
import { states } from "../../../../utils/states";
import { handleCep } from "../../../../utils/handleCep";
import { queryClient } from "../../../../utils/queryClient";
import { getContrastColor } from "../../../../utils/getContrastColor";
//hooks
import { useOptionsSelect } from "../../../../hooks/useOptionsSelect";
//services
import { putLead } from "../../../../services/Crm/Funnel/putLead";
import { getLead } from "../../../../services/Crm/Funnel/getLead";
import { getOrigins } from "../../../../services/Crm/Settings/Origins/getOrigins";
import { getTeamList } from "../../../../services/GlobalRoles/getTeamList";
import { getStatusFunnel } from "../../../../services/Crm/Settings/Status/getStatusFunnel";
import { patchLeadStatus } from "../../../../services/Crm/Funnel/patchLeadStatus";
import { getFormLeadConfig } from "../../../../services/Crm/Settings/FormLead/getFormLeadConfig";
import { getFunnelWithStatus } from "../../../../services/Crm/Settings/Funnel/getFunnelWithStatus";

const ModalLeadDetails = ({ visible, setVisible, leadId, idFunnel, defaultActiveIndex }) => {
  const form = useForm();
  const formStatus = useForm();
  const [events, setEvents] = useState([]);
  const [address, setAddress] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex ?? 0);
  const [statusOptions, setStatusOptions] = useState([]);
  const [originsSelect, setOriginsSelect] = useState([]);
  const [funnelsOptions, setFunnelsOptions] = useState([]);
  const [inputRequireds, setInputRequireds] = useState([]);
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [isLoadingTeams, setIsLoadingTeams] = useState(false);
  const {
    enterprise,
    isLoadingEnterprises,
    selectTeam,
    brokers,
    isLoadingBroker,
  } = useOptionsSelect();
  const steps = [
    { label: "Dados do Lead" },
    { label: "Histórico de Atendimento" },
    { label: "Tratativa do Lead" },
  ];

  const { data: _, isLoading: isLoadingOrigins } = useQuery({
    queryKey: [`origins`],
    queryFn: () => getOrigins(),
    onSuccess: (data) => {
      const options = data.map((o) => {
        return {
          value: o.id,
          label: o.name,
        };
      });
      setOriginsSelect(options);
    },
    refetchOnWindowFocus: false,
  });

  useQuery({
    queryKey: [`formLead`],
    queryFn: () => getFormLeadConfig(),
    onSuccess: (data) => {
      const requiredFields = data?.required.map((field) => field.name);
      setInputRequireds(requiredFields);
    },
  });

  const { data: funnels, isLoading: isLoadingFunnels } = useQuery({
    queryKey: [`funnels`],
    queryFn: () => getFunnelWithStatus(),
    refetchOnWindowFocus: false,
  });

  const { data: status, isLoading: isLoadingStatus } = useQuery({
    queryKey: [`statusFunnel`],
    queryFn: () => getStatusFunnel(),
  });

  const { mutateAsync: putLeadFn } = useMutation(putLead, {
    onSuccess: (res) => {
      const updatedLead = res.success;
      queryClient.setQueryData(["kanban", idFunnel], (old) => {
        if (!old || !Array.isArray(old.status)) return old;
        return {
          ...old,
          status: old.status.map((col) => ({
            ...col,
            leads: col.leads.map((lead) =>
              lead.id === updatedLead.id
                ? {
                    ...lead,
                    ...updatedLead,
                    address: updatedLead.address ?? lead.address,
                    pivot: {
                      ...lead.pivot,
                    },
                  }
                : lead
            ),
          })),
        };
      });
    },
  });

  const { mutateAsync: moveLeadAsync } = useMutation(
    (payload) => patchLeadStatus(payload),
    {
      onSuccess: (_res, payload) => {
        let movedLead;

        queryClient.setQueryData(["kanban", idFunnel], (old) => {
          if (!old) return old;

          const newStatus = old.status.map((col) => ({
            ...col,
            leads: [...col.leads],
          }));

          const sourceCol = newStatus.find((col) =>
            col.leads.some((l) => l.id === payload.lead_id)
          );
          if (!sourceCol) return old;

          const idx = sourceCol.leads.findIndex(
            (l) => l.id === payload.lead_id
          );
          [movedLead] = sourceCol.leads.splice(idx, 1);

          movedLead.pivot.updated_at = new Date().toISOString();

          if (payload.funnel_id === idFunnel) {
            const destCol = newStatus.find(
              (col) => col.id === payload.status_id
            );
            if (destCol) destCol.leads.push(movedLead);
          }

          return { ...old, status: newStatus };
        });

        if (payload.funnel_id !== idFunnel) {
          queryClient.setQueryData(["kanban", payload.funnel_id], (old) => {
            if (!old) return old;

            const newStatus = old.status.map((col) => ({
              ...col,
              leads: [...col.leads],
            }));

            const destCol = newStatus.find(
              (col) => col.id === payload.status_id
            );
            if (destCol && movedLead) {
              destCol.leads.push(movedLead);
            }

            return { ...old, status: newStatus };
          });
        }
      },

      onError: () => {
        toast.error("Erro ao mover lead!");
      },
    }
  );

  const selectEnterprise = async (enterprise_id) => {
    setIsLoadingTeams(true);
    try {
      const response = await getTeamList(enterprise_id);
      const options = response.map((o) => ({
        value: o.id,
        label: o.name,
      }));
      setTeamsOptions(options);
      setIsLoadingTeams(false);
    } catch (error) {
      console.error("Error fetching team list:", error);
      setIsLoadingTeams(false);
    }
  };

  const customizedMarker = (item, index) => {
    const isLastPosition = index === events.length - 1;

    return (
      <>
        <Tooltip
          target={`#status_${item.id}`}
          content={isLastPosition ? "Atual" : "Concluído"}
          position="top"
        />
        <span
          id={`status_${item.id}`}
          className="flex align-items-center justify-content-center text-white border-circle z-1 shadow-1"
          style={{
            backgroundColor: isLastPosition ? "#00ACAC" : "#FF5B57",
            width: 15,
            height: 15,
            borderRadius: 10,
          }}
        ></span>
      </>
    );
  };

  const handleEdit = async (data) => {
    const notification = toast.loading("Atualizando Lead...");
    setLoadingButton(true);
    const leadData = {
      lead_id: leadId,
      name: data.name,
      email: data.email,
      phone: data.phone,
      address: {
        cep: data.cep,
        num: data.num,
        complement: data.complement,
        city: data.city,
        state: data.state,
        address: data.address,
        neighborhood: data.neighborhood,
      },
      origin_id: data.origin_id,
      enterprise_id: data.enterprise_id,
      team_id: data.team_id,
      broker_id: data.broker_id,
      ...(data.obs ? { obs: data.obs } : {}),
    };
    try {
      await putLeadFn(leadData);
      toast.update(notification, {
        render: "Lead atualizado com sucesso!",
        autoClose: 2000,
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 2000,
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };

  const handleSaveStatus = async (data) => {
    const notification = toast.loading("Atualizando Lead...");
    setLoadingButton(true);
    const leadData = {
      lead_id: leadId,
      status_id: data.status_id,
      funnel_id: data.funnel_id,
      ...(data.obs ? { obs: data.obs } : {}),
    };

    try {
      await moveLeadAsync(leadData);
      toast.update(notification, {
        render: "Lead atualizado com sucesso!",
        autoClose: 2000,
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 2000,
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };
  const { data: lead, isLoading: isLoadingLead } = useQuery({
    queryKey: [`lead${leadId}`],
    queryFn: () => getLead(leadId),
    enabled: !!leadId,
  });

  useEffect(() => {
    if (!lead) return;
    form.reset({
      name: lead.name,
      email: lead.email,
      phone: lead.phone,
      cep: lead.address?.cep,
      num: lead.address?.num,
      complement: lead.address?.complement,
      city: lead.address?.city,
      state: lead.address?.state,
      address: lead.address?.address,
      neighborhood: lead.address?.neighborhood,
      origin_id: lead.origin_id,
      enterprise_id: lead.enterprise_id,
      obs: lead.obs,
    });
    
    // Pré-setar funil e status do lead no formStatus
    const currentFunnel = lead.funnels && lead.funnels.length > 0 ? lead.funnels[0] : null;
    const currentStatus = lead.status && lead.status.length > 0 ? lead.status[0] : null;
    
    formStatus.reset({
      funnel_id: currentFunnel?.id || null,
      status_id: currentStatus?.id || null,
      obs: ""
    });
    
    if (lead.enterprise_id) {
      (async () => {
        await selectEnterprise(lead.enterprise_id);
        form.setValue("team_id", lead.team_id);
      })();
      if (lead.team_id) {
        (async () => {
          await selectTeam(lead.team_id);
          form.setValue("broker_id", lead.broker_id);
        })();
      }
    }
  }, [lead, form, formStatus]);

  useEffect(() => {
    if (!lead) return;
    if (lead.lead_progress) {
      const mapped = lead.lead_progress.map((ev) => ({
        id: ev.id,
        status: ev.status,
        funnel: ev.funnel?.name,
        user: ev.user?.name || "—",
        date: new Date(ev.updated_at).toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
        obs: ev.obs || "",
      }));
      setEvents(mapped);
    }
  }, [lead?.lead_progress]);

  useEffect(() => {
    if (funnels?.funnels) {
      const options = funnels.funnels.map((funnel) => ({
        label: funnel.name,
        value: funnel.id,
      }));
      setFunnelsOptions([...options]);
    }
  }, [funnels]);

  useEffect(() => {
    if (status) {
      const options = status.map((s) => ({
        label: s.name,
        value: s.id,
      }));
      setStatusOptions([...options]);
    }
  }, [status]);

  useEffect(() => {
    if (address && Object.keys(address).length !== 0) {
      form.setValue("address", address.address);
      form.setValue("city", address.city);
      form.setValue("neighborhood", address.neighborhood);
      form.setValue("state", address.state);
    }
  }, [address]);

  return (
    <Modal
      dynamicTitle="Ficha de Atendimento"
      visible={visible}
      onHide={() => {
        setVisible(false);
      }}
    >
      {isLoadingLead ? (
        <Skeleton width="100%" height={500} className="mb-2" />
      ) : (
        <>
          <Steps
            model={steps}
            className="mt-2"
            activeIndex={activeIndex}
            onSelect={(e) => setActiveIndex(e.index)}
            readOnly={false}
          />
          <div className="p-mt-3">
            {activeIndex === 0 && (
              <div>
                <form onSubmit={form.handleSubmit(handleEdit)}>
                  <div className="row">
                    <div className={"col-md-4 my-2"}>
                      <Input
                        name="name"
                        label={`Nome Completo ${
                          inputRequireds.includes("name") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("name")}
                        className="w-100"
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className={"col-md-4 my-2"}>
                      <Input
                        name="email"
                        label={`E-mail ${
                          inputRequireds.includes("email") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("email")}
                        errors={form.formState.errors}
                        control={form.control}
                        type="email"
                        validationRules={{
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "E-mail inválido.",
                          },
                        }}
                      />
                    </div>
                    <div className={"col-md-4 my-2"}>
                      <MaskInput
                        name="phone"
                        label={`Telefone ${
                          inputRequireds.includes("phone") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("phone")}
                        mask="(99) 9999?9-9999"
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <div className="inline-flex align-items-center">
                        <i className="pi pi-map me-2"></i>
                        <b>Endereço</b>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <MaskInput
                        name="cep"
                        label={`CEP ${
                          inputRequireds.includes("cep") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("cep")}
                        mask="99999-999"
                        onComplete={() =>
                          handleCep(form.getValues("cep"), setAddress)
                        }
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className="col-md-3">
                      <Input
                        name="num"
                        label={`Número ${
                          inputRequireds.includes("numero") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("numero")}
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        name="complement"
                        label={`Complemento ${
                          inputRequireds.includes("complement") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("complement")}
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className="col-md-3 mt-2">
                      <Input
                        name="city"
                        label={`Cidade ${
                          inputRequireds.includes("city") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("city")}
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>

                    <div className="col-md-3 mt-2">
                      <Select
                        name="state"
                        label={`Estado ${
                          inputRequireds.includes("state") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("state")}
                        errors={form.formState.errors}
                        control={form.control}
                        options={states}
                      />
                    </div>
                    <div className="col-md-3 mt-2">
                      <Input
                        name="address"
                        label={`Rua ${
                          inputRequireds.includes("address") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("address")}
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>
                    <div className="col-md-3 mt-2">
                      <Input
                        name="neighborhood"
                        label={`Bairro ${
                          inputRequireds.includes("neighborhood") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("neighborhood")}
                        control={form.control}
                        errors={form.formState.errors}
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="inline-flex align-items-center">
                        <i className="pi pi-folder-open me-2"></i>
                        <b>Tratativa do cliente</b>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <Select
                        name="origin_id"
                        label={`Origem ${
                          inputRequireds.includes("origin_id") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("origin_id")}
                        disabled={isLoadingOrigins}
                        errors={form.formState.errors}
                        control={form.control}
                        options={originsSelect}
                      />
                    </div>
                    <div className="col-md-3">
                      <Select
                        name="enterprise_id"
                        label={`Interesse ${
                          inputRequireds.includes("enterprise_id") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("enterprise_id")}
                        errors={form.formState.errors}
                        disabled={isLoadingEnterprises}
                        onChange={(e) => selectEnterprise(e)}
                        control={form.control}
                        options={enterprise}
                      />
                    </div>
                    <div className="col-md-3">
                      <Select
                        name="team_id"
                        label={
                          isLoadingTeams
                            ? "Carregando..."
                            : `Time ${
                                inputRequireds.includes("team_id") ? "*" : ""
                              }`
                        }
                        isRequired={inputRequireds.includes("team_id")}
                        control={form.control}
                        errors={form.formState.errors}
                        onChange={(e) => selectTeam(e)}
                        disabled={isLoadingTeams}
                        options={teamsOptions}
                      />
                    </div>
                    <div className="col-md-3">
                      <Select
                        name="broker_id"
                        label={
                          isLoadingBroker
                            ? "Carregando..."
                            : `Corretor ${
                                inputRequireds.includes("broker_id") ? "*" : ""
                              }`
                        }
                        isRequired={inputRequireds.includes("broker_id")}
                        errors={form.formState.errors}
                        disabled={isLoadingBroker}
                        control={form.control}
                        options={brokers}
                      />
                    </div>
                    <div className="col-md-12">
                      <TextareaInput
                        name="obs"
                        label={`Observações ${
                          inputRequireds.includes("obs") ? "*" : ""
                        }`}
                        isRequired={inputRequireds.includes("obs")}
                        className="mt-4"
                        errors={form.formState.errors}
                        control={form.control}
                      />
                    </div>
                    <div className="row justify-content-end">
                      <div className="col-md-3 pt-3 justify-content-end d-flex">
                        <Button
                          rounded
                          type="submit"
                          label="Editar"
                          iconPos="right"
                          loading={loadingButton}
                          className="p-inputtext-sm w-100"
                          icon="fa-solid fa-pen-to-square"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
            {activeIndex === 1 && (
              <div>
                <div
                  style={{
                    maxHeight: "350px",
                    overflowY: "scroll",
                  }}
                >
                  <Timeline
                    value={events}
                    className="customized-timeline p-4"
                    marker={customizedMarker}
                    opposite={(item) => (
                      <>
                        <span
                          className="badge"
                          style={{
                            fontSize: "10px",
                            marginLeft: "5px",
                            backgroundColor: item.status.color,
                            color: getContrastColor(item.status.color),
                          }}
                        >
                          {item.status.name}
                        </span>
                        <p className={item.status ? "" : "text-muted"}>
                          {item.funnel ?? "Sem funil"}
                        </p>
                        <small
                          className={`text-color-secondary ${
                            item.status === 1 ? "" : "text-muted"
                          }`}
                          style={{ fontSize: "11px", display: "block", marginTop: "4px" }}
                        >
                          {item.date}
                        </small>
                      </>
                    )}
                    content={(item) => (
                      <>
                        <small
                          className={`text-color-secondary ${
                            item.status ? "" : "text-muted"
                          }`}
                        >
                          {item.user}:
                        </small>
                        {item.obs && (
                          <>
                            <br />
                            <small
                              className={`text-color-secondary ${
                                item.status ? "" : "text-muted"
                              }`}
                              style={{ fontSize: "11px", fontStyle: "italic" }}
                            >
                              {item.obs}
                            </small>
                          </>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>
            )}
            {activeIndex === 2 && (
              <div>
                <form onSubmit={formStatus.handleSubmit(handleSaveStatus)}>
                  <div className="row">
                    <div className="col-md-12">
                      <TextareaInput
                        name="obs"
                        label="Descrição do Atendimento"
                        className="mt-4"
                        errors={formStatus.formState.errors}
                        control={formStatus.control}
                      />
                    </div>
                    <div className="col-md-6">
                      <Select
                        name="funnel_id"
                        control={formStatus.control}
                        options={funnelsOptions}
                        disabled={isLoadingFunnels}
                        errors={formStatus.formState.errors}
                        label={isLoadingFunnels ? "Carregando..." : `Funil`}
                      />
                    </div>
                    <div className="col-md-6">
                      <Select
                        isRequired
                        name="status_id"
                        control={formStatus.control}
                        options={statusOptions}
                        disabled={isLoadingStatus}
                        errors={formStatus.formState.errors}
                        label={isLoadingStatus ? "Carregando..." : `Status`}
                      />
                    </div>
                    <div className="row justify-content-end">
                      <div className="col-md-3 pt-3 justify-content-end d-flex">
                        <Button
                          rounded
                          type="submit"
                          label="Salvar"
                          iconPos="right"
                          loading={loadingButton}
                          className="p-inputtext-sm w-100"
                          icon="fa-solid fa-circle-chevron-right"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};

export default ModalLeadDetails;
